<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'Home'"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="5000" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @dragstart.prevent />
							<div v-if="index == 0" class="msg_box">
								<img src="../../assets/img_public/logo_b.webp" />
								<div class="tit">Coretests provides full-cycle support from life’s conception<br /> to its completion. <span>@2.1 Billion People</span></div>
								<div class="tips" @click="goMore">
									More&nbsp;<van-icon name="arrow" size="16px" color="#000000" style="position: relative;top: 3px;" />
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div class="indicators_box">
					<div v-for="(value, index) in bannerList" :key="index" class="indicators_el" :class="bannerIndex == index ? 'actived' : ''"></div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="tit_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_tit">Product Certifications</div>
				</div>
				<div v-if="sceneList.length > 0" class="list_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div v-for="(value, index) in sceneList" :key="index" class="list_el" @click="goProduct(value)">
						<img :src="webUrl + value.thumb" />
						<div class="msg_box">
							<div class="tit">{{ value.title }}</div>
							<div v-if="value.title == 'CE'" class="txt">Conformite Europeenne</div>
							<div v-if="value.title == 'FDA'" class="txt">U.S.Food & Drug Administration</div>
							<div v-if="value.title == 'NMPA'" class="txt">National Medical Products Administration</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="top_box">
					<div class="tit_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">About Coretests</div>
						<div class="right" @click="goMore">
							<div class="public_btn">More<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="txt_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Core Technology Co., Ltd. is a subsidiary of the American CorDx Union group. CorDx Union (hereinafter referred to as CU) was established in 2006, serving as an international group company integrating R&D, production, marketing, and service. It has 21 subsidiaries, including Accu News, Coretests technology, Abiores, Jtests, Bonore plastics, CuPet and other brands. 
					</div>
				</div>
				<div class="bot_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img class="bg" src="../../assets/img_public/index/block_bg2.webp" />
					<div class="bot_main">
						<div class="title">Our products are sold to more than 120 countries and regions,<br />with more than 1billion users worldwide.</div>
						<div class="info_box">
							<div class="left">
								<div class="info_el">
									<img src="../../assets/img_public/index/icon1.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="170" :duration="6000" class="num"></count-to>
											<div class="add" style="right: 0;">+</div>
										</div>
										<br />
										<div class="tit">Market coverage countries and regions</div>
									</div>
								</div>
								<div class="info_el">
									<img src="../../assets/img_public/index/icon2.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="100" :duration="6000" class="num"></count-to>
											<div class="add" style="left: 110px;">+</div>
											<div class="count" style="left: 110px;">Million</div>
										</div>
										<br />
										<div class="tit">Users</div>
									</div>
								</div>
							</div>
							<div class="right">
								<div class="info_el">
									<img src="../../assets/img_public/index/icon3.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="50" :duration="6000" class="num"></count-to>
											<div class="add" style="right: 30px;">+</div>
										</div>
										<br />
										<div class="tit">Qualifications and certifications</div>
									</div>
								</div>
								<div class="info_el">
									<img src="../../assets/img_public/index/icon4.webp" />
									<div class="info_info">
										<div class="info_info_box">
											<count-to :startVal="0" :endVal="30" :duration="6000" class="num"></count-to>
											<div class="add" style="right: 28px;font-size: 16px;">㎡</div>
											<div class="count" style="right: -15px;">Thousand</div>
										</div>
										<br />
										<div class="tit">Area of industrial base</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="top_box">
					<div class="tit">Globalization</div>
					<div class="txt">
						With the goal of becoming a first-class pharmaceutical enterprise, our companies is committed to the development of
						<br />globalization. Now it has established R & D centers, production bases and sales platforms in the United States, Britain, Dubai
						<br />and Singapore to serve the cause of human health wholeheartedly!
					</div>
				</div>
				<div class="bot_box">
					<div class="shadow"></div>
					<div id="mapBox" class="map_box"></div>
					<div class="list_box">
						<div class="top_list">
							<div :class="addressActived == 1 ? 'actived' : ''" @click="addressClick(1)">Overseas Companies</div>
							<div :class="addressActived == 2 ? 'actived' : ''" @click="addressClick(2)">Domestic Companies</div>
						</div>
						<div class="bot_list">
							<template v-if="addressActived == 1">
								<div v-for="(value, index) in addressOut" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
							</template>
							<template v-if="addressActived == 2">
								<div v-for="(value, index) in addressIn" :key="index" :class="addressActived2 == value.title ? 'actived' : ''" @click="addressClick2(value)">{{ value.title }}</div>
							</template>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="tit_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="left">Company News</div>
						<div class="right" @click="goNews">
							<div class="public_btn">More<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="list_box">
						<div v-if="newsOneList" class="left"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goNewsInfo(newsOneList)"
						>
							<img :src="webUrl + newsOneList.image" />
							<div class="title_box">
								<div class="tit">{{ newsOneList.title }}</div>
								<div class="time">{{ newsOneList.fabu_time }}</div>
							</div>
						</div>
						<div v-if="newsOtherList.length > 0" class="right"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div v-for="(value, index) in newsOtherList" :key="index" class="list_el" @click="goNewsInfo(value)">
								<div class="tit">{{ value.title }}</div>
								<div class="txt">{{ value.description }}</div>
								<div class="time">{{ value.fabu_time }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="block_5_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img_public/index/zw2.webp" />
						<div class="tit">Corporate Culture</div>
						<div class="txt">Perfect quality, sincere service,<br />standardized management, development and innovation</div>
						<div class="btn_box">
							<div class="public_btn" @click="goCulture">More<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img_public/index/zw3.webp" />
						<div class="tit">Cordxer</div>
						<div class="txt">Grow together and create a better future for CU.</div>
						<div class="btn_box">
							<div class="public_btn" @click="goMore">More<van-icon name="arrow" size="16px" class="btn_icon" /></div>
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import CountTo from 'vue-count-to'
import AMapLoader from '@amap/amap-jsapi-loader';
import { UPURL } from '@/util/util';
import { newsList } from '@/api/public';  //新闻列表
export default {
	components:{
		navBox,
		footerBox,
		CountTo
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [  //轮播
				{ imgUrl: require('@/assets/img_public/index/banner01.webp') },
				{ imgUrl: require('@/assets/img_public/index/banner02.webp') }
			],
			bannerIndex: 0,  //当前轮播索引
			addressActived: 1,
			addressActived2: 'SD,California,USA',
			addressIn: [
				{ title: 'BeiJing', lat: 40.287037, lng: 116.227463 },
				{ title: 'TianJin', lat: 39.588283, lng: 117.063738 },
				{ title: 'HeBei', lat: 39.24455, lng: 115.515995 },
				{ title: 'HeNan', lat: 35.217431, lng: 113.676265 },
				{ title: 'HuBei', lat: 30.527296, lng: 113.924629 },
				{ title: 'HaiNan', lat: 20.254845, lng: 109.76684 }
			],
			addressOut: [
				{ title: 'SD,California,USA', lat: 33.21698, lng: -117.160338 },
				{ title: 'Atlanta,Georgia,USA', lat: 33.693296, lng: -84.344735 },
				{ title: 'Singapore', lat: 1.341561, lng: 103.888903 },
				{ title: 'Dubai', lat: 25.237182, lng: 55.356834 }
			],
			mapList: null,
			loaction: null,
			sceneList: [],  //产品认证
			lang: 'en',
			lang2: sessionStorage.getItem('lang'),
			webUrl: UPURL,
			newsOneList: null,
			newsOtherList: [],
		}
	},
	created(){
		let that = this;
		//产品分类赋值
		that.sceneList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cert_list;
		//请求文章数据
		newsList({
			page: 1,
			page_size: 4,
			leixing: 1,
			language: sessionStorage.getItem('lang')
		}).then(res => {
			res.data.data.forEach((value, index) => {
				if(index == 0) {
					that.newsOneList = value;
				}else {
					that.newsOtherList.push(value);
				}
			});
		});
	},
	mounted() {
		let that = this;
		//初始化地图
		that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
		that.loaction = [-117.160338, 32.71698];
		that.$nextTick(() => {
			that.initMap();
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//跳转文章详情
		goNewsInfo(value) {
			let that = this;
			let routeData = that.$router.resolve({name: "NewsInfo", params: { newInfoId: value.id + '.html' } });
			window.open(routeData.href, '_blank');
		},
		//跳转新闻
		goNews() {
			this.$router.push('/news/dynamics.html');
		},
		//跳转企业文化
		goCulture() {
			this.$router.push('/about/culture.html');
		},
		//跳转公司简介
		goMore() {
			this.$router.push('/about/introduction.html');
		},
		//点击跳转产品
		goProduct(value) {
			let that = this;
			that.$router.push({ path: '/product-list.html', query: { cert_ids: value.id, } });
		},
		//地点点击2
		addressClick2(value) {
			let that = this;
			if(that.addressActived2 != value.title) {
				that.addressActived2 = value.title;
				//重置地图
				that.mapList = [{ lnglats: [value.lng, value.lat], }];
				that.loaction = [value.lng, value.lat];
				that.initMap();
			}
		},
		//地点点击1
		addressClick(value) {
			let that = this;
			that.addressActived = value;
			if(that.addressActived == 1) {
				that.lang = 'en';
				that.addressActived2 = 'SD,California,USA';
				//重置地图
				that.mapList = [{ lnglats: [-117.160338, 33.21698], }];
				that.loaction = [-117.160338, 33.21698];
				that.initMap();
			}else {
				that.lang = 'en';
				that.addressActived2 = 'BeiJing';
				//重置地图
				that.mapList = [{ lnglats: [116.227463, 40.287037], }];
				that.loaction = [116.227463, 40.287037];
				that.initMap();
			}
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
		//初始化地图
		initMap() {
			let that = this;
			AMapLoader.load({
				key:"1a79407995c8bc2abb2230330562814e",  // 申请好的Web端开发者Key，首次调用 load 时必填  c7422fb1c71586f2ab0e00eeeda9ea3e
				version:"1.4.15",  // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
				plugins:[''],  // 需要使用的的插件列表，如比例尺'AMap.Scale'等
			}).then((AMap)=>{
				that.map = new AMap.Map("mapBox",{  //设置地图容器id
					viewMode:"3D",    //是否为3D地图模式
					zoom: 0,           //初始化地图级别
					//mapStyle: 'amap://styles/whitesmoke',
					center: that.loaction, //初始化地图中心点位置640419
					lang: ''
				});
				that.setMapMarker();
				that.map.setZoom(6);
				that.map.setLang(that.lang);
			}).catch(e=>{
				console.log(e);
			});
		},
		setMapMarker () {
			let that = this;
			// 创建 AMap.Icon 实例
			let icon = new AMap.Icon({
				size: new AMap.Size(36, 36), // 图标尺寸
				image: "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png", // Icon的图像
				imageSize: new AMap.Size(24, 30), // 根据所设置的大小拉伸或压缩图片
				imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
			});
			let makerList = []
			that.mapList.forEach((item) => {
				// 遍历生成多个标记点
				let marker = new AMap.Marker({
					map: that.map,
					zIndex: 9999999,
					icon: icon, // 添加 Icon 实例
					offset: new AMap.Pixel(0, 0), //icon中心点的偏移量
					position: item.lnglats // 经纬度对象new AMap.LngLat(x, y)，也可以是经纬度构成的一维数组[116.39, 39.9]
				});
				makerList.push(marker)
			});
			that.map.add(makerList)
		    that.map.setFitView();
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块5
	.block_5{
		.block_5_main{
			width: 1264px;
			display: flex;
			margin: 0 auto;
			padding: 100px 0;
			.left, .right{
				flex: 1;
				padding-right: 40px;
				.txt{
					padding: 10px 0 30px 0;
					font-size: 18px;
				}
				.tit{
					padding-top: 30px;
					font-size: 28px;
				}
				img{
					width: 100%;
				}
			}
			.right{
				padding-left: 40px;
				padding-right: 0;
			}
		}
	}
	//块4
	.block_4{
		padding: 100px 0 80px 0;
		background: url(../../assets/img_public/index/block_bg.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_4_main{
			width: 1264px;
			margin: 0 auto;
			.list_box{
				display: flex;
				align-items: center;
				padding-top: 45px;
				.right{
					flex: 1;
					padding-left: 40px;
					.list_el{
						margin-bottom: 20px;
						padding: 0 0 16px 0;
						border-bottom: 1px solid #E3E1E6;
						cursor: pointer;
						.tit{
							font-size: 22px;
						}
						.txt{
							margin: 10px 0 8px 0;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							font-size: 16px;
						}
						.time{
							font-size: 16px;
							color: #999999;
						}
					}
				}
				.left{
					flex: 1;
					padding-right: 40px;
					border-radius: 8px;
					overflow: hidden;
					cursor: pointer;
					.title_box{
						padding: 20px 24px 24px 24px;
						background-color: #ffffff;
						.time{
							margin-top: 15px;
							color: #999999;
							font-size: 16px;
						}
						.tit{
							font-size: 20px;
						}
					}
					img{
						width: 100%;
					}
				}
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					flex: 1;
					padding-left: 50px;
				}
				.left{
					width: auto;
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
	//块3
	.block_3{
		padding-top: 100px;
		.bot_box{
			position: relative;
			.shadow{
				display: none;
				// width: 100%;
				// height: 154px;
				// position: absolute;
				// z-index: 1;
				// top: 0;
				// background: #ffffff;
				// opacity: 0.2;
			}
			.list_box{
				width: 1110px;
				left: 50%;
				transform: translate(-50%, 0);
				bottom: 60px;
				position: absolute;
				z-index: 1;
				.bot_list{
					display: flex;
					margin-top: 30px;
					padding: 38px 0;
					background: #FFFFFF;
					box-shadow: 0px 0px 30px 1px rgba(0,0,0,0.1);
					border-radius: 8px;
					text-align: center;
					div{
						flex: 1;
						font-size: 20px;
						cursor: pointer;
						border-right: 1px solid #E3E1E6;
					}
					div:hover{
						color: #A20073;
					}
					div.actived{
						color: #A20073;
					}
					div:last-child{
						border-right: none;
					}
				}
				.top_list{
					div{
						display: inline-block;
						margin-right: 20px;
						padding: 12px 20px 8px 20px;
						border-radius: 8px;
						cursor: pointer;
						font-size: 20px;
					}
					div.actived{
						color: #A20073;
						background-color: #ffffff;
					}
				}
			}
			.map_box{
				width: 100%;
				height: 600px;
			}
		}
		.top_box{
			width: 1264px;
			margin: 0 auto;
			text-align: center;
			.txt{
				padding: 20px 0 40px 0;
				font-size: 20px;
			}
			.tit{
				font-size: 44px;
				font-weight: bold;
			}
		}
	}
	//块2
	.block_2{
		padding-top: 100px;
		.bot_box{
			position: relative;
			.bot_main{
				width: 1264px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				.info_box{
					display: flex;
					padding: 20px 0 0px 0;
					.left, .right{
						flex: 1;
						.info_el{
							padding-top: 60px;
							.info_info{
								width: 360px;
								margin-left: 40px;
								padding: 0 0 0px 0px;
								display: inline-block;
								border-bottom: 1px solid #E3E1E6;
								.info_info_box{
									width: 120px;
									display: inline-block;
									position: relative;
									.count{
										position: absolute;
										bottom: 16px;
										font-size: 14px;
										line-height: 1;
										color: #A20073;
									}
									.add{
										position: absolute;
										top: 0;
										font-size: 24px;
										line-height: 1;
										color: #A20073;
									}
									.num{
										font-size: 62px;
										color: #A20073;
										line-height: 1;
									}
								}
								.tit{
									padding-top: 20px;
									margin-left: 0px;
									display: inline-block;
									position: relative;
									top: -16px;
								}
							}
							img{
								width: 48px;
								height: 48px;
							}
						}
					}
				}
				.title{
					font-size: 30px;
				}
			}
			img.bg{
				min-width: 1264px;
				width: 100%;
			}
		}
		.top_box{
			width: 1264px;
			margin: 0 auto;
			.txt_box{
				padding: 20px 0 50px 0;
				font-size: 20px;
			}
			.tit_box{
				display: flex;
				align-items: center;
				.right{
					flex: 1;
					padding-left: 50px;
				}
				.left{
					width: auto;
					font-size: 44px;
					font-weight: bold;
				}
			}
		}
	}
	//块1
	.block_1{
		.list_box{
			width: 1264px;
			margin: 0 auto;
			padding-top: 100px;
			display: flex;
			.list_el{
				flex: 1;
				position: relative;
				margin-right: 25px;
				cursor: pointer;
				.msg_box{
					width: 75%;
					position: absolute;
					top: 45%;
					left: 50%;
					transform: translate(-50%, -50%);
					text-align: center;
					color: #A20073;
					.txt{
						padding-top: 5px;
						font-size: 24px;
					}
					.tit{
						font-size: 36px;
					}
				}
				img{
					width: 100%;
				}
			}
			.list_el:last-child{
				margin-right: 0;
			}
		}
		.tit_box{
			padding: 45px 0 40px 0;
			// border-bottom: 1px solid #E3E1E6;
			.tit_tit{
				width: 1264px;
				margin: 0 auto;
				font-size: 48px;
				font-weight: bold;
			}
		}
	}
	//轮播图
	.banner_box{
		min-width: 1300px;
		position: relative;
		.indicators_box{
			position: absolute;
			bottom: 50px;
			left: 50%;
			transform: translate(-50%, 0);
			.indicators_el{
				width: 100px;
				height: 2px;
				display: inline-block;
				margin: 0 5px;
				background-color: rgba(0, 0, 0, 0.3);
			}
			.actived{
				background-color: #A20073;
			}
		}
		.swipe_box{
			.swiper_el{
				position: relative;
				.msg_box{
					width: 1264px;
					margin: 0 auto;
					position: absolute;
					top: 40%;
					left: 50%;
					transform: translate(-50%, -40%);
					.tips{
						margin-top: 80px;
						display: inline-block;
						font-size: 16px;
						padding: 8px 16px;
						border-radius: 8px;
						border: 1px solid #999999;
					}
					.tit{
						margin-top: 20px;
						font-size: 24px;
						span{
							font-size: 24px;
							font-weight: bold;
							color: #A20073;
						}
					}
					img{
						width: 470px;
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>